import { IUserActionTypes, ImpersonateUserState } from 'types';
import { Reducer } from 'redux';

const initialState: ImpersonateUserState = {
  loading: false,
  token: '',
  user: {},
  expiry: ''
};

const reducer: Reducer<ImpersonateUserState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case IUserActionTypes.FETCH_IUSER_START: {
      return {
        ...state,
        loading: true
      };
    }
    case IUserActionTypes.FETCH_IUSER_SUCCESS: {
      const { token, User, expiry } = action.payload;
      return {
        ...state,
        token,
        user: User,
        expiry
      };
    }
    case IUserActionTypes.FETCH_IUSER_FAILURE: {
      return {
        ...state,
        error: action.payload
      };
    }

    default:
      return state;
  }
};

export { reducer as IUserReducer };
